import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { environment } from '@hospitality-bot/admin/environment';
import { TranslateModule } from '@ngx-translate/core';
import { getTranslationConfigs } from 'libs/admin/shared/src/lib/configs/translate';
import { AuthModule } from './auth/auth.module';
import systemInterceptors from './configs/interceptor';
import { EnsureModuleLoadedOnceGuard } from './ensure-module-loaded-once.guard';
import { googleMapsInitializer } from './utils/google-maps-loader';

export function initGoogleMaps(): () => Promise<void> {
  return googleMapsInitializer(environment.googleMapsApiKey);
}

import { MessageService } from 'primeng/api';
import { SnackBarService } from '@hospitality-bot/shared/material';

@NgModule({
  declarations: [],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    AuthModule,
    BrowserModule,
    CommonModule,
    RouterModule,
    TranslateModule.forRoot(
      getTranslationConfigs([HttpClient], ['core', 'auth', 'errors'])
    ),
  ],
  providers: [
    ...systemInterceptors,
    MessageService,
    SnackBarService,
    {
      provide: APP_INITIALIZER,
      useFactory: initGoogleMaps,
      multi: true,
    },
  ],
})
export class CoreModule extends EnsureModuleLoadedOnceGuard {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    super(parentModule);
  }
}
